<template>
    <v-lightbox foot-class="justify-between px-7" is-authenticated>
        <template v-slot:trigger>
            <a @click="show = true" class="button button--white">
                <v-icon icon="sort"></v-icon>
                Razvrsti po
            </a>
        </template>
        <template v-slot:head>
            <v-icon icon="sort" class="mr-2.5"></v-icon>
            Razvrsti po
        </template>
        <template v-slot:content>
            <form :action="submit_url" id="sortForm">
                <div class="hidden">
                    <div v-for="query in nonSearchQuery">
                        <input type="hidden" :name="query.name" :value="query.value"/>
                    </div>
                </div>
                <div class="hidden" v-if="sortByDirection !== null && sortByField !== null">
                    <input type="hidden" :name="sortByField" :value="sortByDirection">
                </div>
                <div class="search-sort flex flex-col gap-8">
                    <section class="flex gap-8">
                        <aside class="flex items-center justify-center">
                            <v-icon icon="euro" size="6"></v-icon>
                        </aside>
                        <main class="flex w-full flex-col gap-[10px]">
                            <figure
                                class="search-sort__option"
                                :class="{ active: activeLabel === 'price-desc' }"
                                @click="toggleActive('price-desc')"
                            >
                                <figcaption>Najvišji ceni</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-up"></v-icon>
                                </div>
                            </figure>
                            <figure
                                class="search-sort__option"
                                :class="{ active: activeLabel === 'price-asc' }"
                                @click="toggleActive('price-asc')"
                            >
                                <figcaption>Najnižji ceni</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-down"></v-icon>
                                </div>
                            </figure>
                        </main>
                    </section>
                    <hr />
                    <section class="flex gap-8">
                        <aside class="flex items-center justify-center">
                            <v-icon icon="square-size" size="6"></v-icon>
                        </aside>
                        <main class="flex w-full flex-col gap-[10px]">
                            <figure
                                class="search-sort__option"
                                :class="{
                                    active: activeLabel === 'size-desc',
                                }"
                                @click="toggleActive('size-desc')"
                            >
                                <figcaption>Največji površini</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-up"></v-icon>
                                </div>
                            </figure>
                            <figure
                                class="search-sort__option"
                                :class="{
                                    active: activeLabel === 'size-asc',
                                }"
                                @click="toggleActive('size-asc')"
                            >
                                <figcaption>Najmanjši površini</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-down"></v-icon>
                                </div>
                            </figure>
                        </main>
                    </section>
                    <hr />
                    <section class="flex gap-8">
                        <aside class="flex items-center justify-center">
                            <v-icon icon="upcoming" size="6"></v-icon>
                        </aside>
                        <main class="flex w-full flex-col gap-[10px]">
                            <figure
                                class="search-sort__option"
                                :class="{ active: activeLabel === 'age-desc' }"
                                @click="toggleActive('age-desc')"
                            >
                                <figcaption>Najnovejše</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-up"></v-icon>
                                </div>
                            </figure>
                            <figure
                                class="search-sort__option"
                                :class="{ active: activeLabel === 'age-asc' }"
                                @click="toggleActive('age-asc')"
                            >
                                <figcaption>Najstarejše</figcaption>
                                <div
                                    class="flex h-[40px] w-[40px] items-center justify-center rounded-lg shadow"
                                >
                                    <v-icon icon="big-arrow-down"></v-icon>
                                </div>
                            </figure>
                        </main>
                    </section>
                </div>
            </form>
        </template>
        <template v-slot:foot>
            <a class="button button--gray" :href="submit_url">
                <v-icon icon="reload"></v-icon>
                Ponastavi
            </a>
            <button class="button" @click="submitForm" id="submitButton">
                <v-icon icon="loupe-list"></v-icon>
                Prikaži
            </button>
        </template>
    </v-lightbox>
</template>

<script>
const allSort = [
    "price",
    "size",
    "age"
];

export default {
    data() {
        return {
            activeLabel: null,
            nonSearchQuery: [],
            sortByField: null,
            sortByDirection: null
        };
    },
    props: {
        query: {
            type: Object,
            required: false,
            default: {}
        },
        submit_url: {
            type: String,
            required: true,
        }
    },
    methods: {
        toggleActive(label) {
            this.activeLabel = label === this.activeLabel ? null : label;

            if(this.activeLabel == null) {
                this.sortByDirection = null;
                this.sortByField = null;
                return;
            }

            let sortBy = label.split("-");
            this.sortByField = sortBy[0];
            this.sortByDirection = sortBy[1];
        },
        prepareOldQuery() {
            for (let [queryParam, queryValue] of Object.entries(this.query)) {
                // Had to hardcode sry...
                if(queryParam == "heating_types") {
                    queryValue.forEach((type) => {
                        this.nonSearchQuery.push({
                            "name": "heating_types[]",
                            "value": type
                        });
                    });
                    continue;
                }

                if(!allSort.includes(queryParam)) {
                    this.nonSearchQuery.push({
                        "name": queryParam,
                        "value": queryValue
                    });
                }
            }
        },
        initCurrentValues() {
            for (const [queryParam, queryValue] of Object.entries(this.query)) {
                if(allSort.includes(queryParam)) {
                    this.activeLabel = queryParam + "-" + queryValue;
                }
            }
        },
        submitForm() {
            document.getElementById("sortForm").submit();
        },
    },
    mounted() {
        this.prepareOldQuery();
        this.initCurrentValues();
    },
};
</script>
